const Rename = (id) => {

  return <>
    <button>rename</button>
  </>
}

export default Rename;
